import { ParameterCodeDataPolicy } from "constants/common/ParameterCodeDataPolicy";
import { AdhocHoldOfCntrEntity, EMPTY_ADHOC_HOLD_OF_CNTR_ENTITY } from "domain/entity/AdhocHoldOfContainer/AdhocHoldOfCntrEntity";
import { AdhocHoldOfCntrSearchCriteria, EMPTY_ADHOC_HOLD_OF_CNTR_SEARCH_CRITERIA } from "domain/entity/AdhocHoldOfContainer/AdhocHoldOfCntrSearchCriteria";
import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { AdhocHoldOfCntrRepository } from "domain/repository/AdhocHoldOfContainer/AdhocHoldOfCntrRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import { AdhocHoldOfCntrModel } from "presentation/model/AdhocHoldOfContainer/AdhocHoldOfCntrModel";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface dhocHoldOfCntrVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<AdhocHoldOfCntrModel>> | ((value: SetStateAction<AdhocHoldOfCntrModel>) => void),
    ],
    adhocHoldOfCntrRepo: AdhocHoldOfCntrRepository,
    parameterDetailRepo: ParameterDetailRepository,
    // consortiumRepo: ConsortiumRepository,
}

export const AdhocHoldOfCntrVM = ({ dispatch, adhocHoldOfCntrRepo, parameterDetailRepo }: dhocHoldOfCntrVMProps) => {
    const [adhocHoldOfCntrDispatch] = dispatch;

    const loadDropdownOption = async () => {

        // await consortiumRepo.getAllConsortiums().then(
        //     consortiums => {
        //         let consortiumCodeDropdownOptions = consortiums?.map((item) => ({
        //             dropdownLabel: item.consortiumCode,
        //             tagLabel: item.consortiumCode,
        //             value: item.consortiumCode,
        //         })) ?? []
        //         consortiumCodeDropdownOptions = _.orderBy(consortiumCodeDropdownOptions, "dropdownLabel");

        //         adhocHoldOfCntrDispatch(prevState => ({
        //             ...prevState,
        //             dynamicOptions: {
        //                 ...prevState.dynamicOptions,
        //                 consortiumCodeDropdownOptions: consortiumCodeDropdownOptions,
        //             }
        //         }))
        //     }
        // );

        await parameterDetailRepo.getAllParameterDtlsByParameterCode(ParameterCodeDataPolicy.ADHOC_HOLD_REASON).then(
            reasonCodeList => {
                const reasonCodeDropdownOption = reasonCodeList?.map((code) => ({
                    dropdownLabel: code.parameterDtlCode,
                    tagLabel: code.parameterDtlCode,
                    value: code.parameterDtlCode,
                })) ?? []

                adhocHoldOfCntrDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        reasonCodeDropdownOptions: reasonCodeDropdownOption
                    }
                }))
            }
        )

    }

    const updateSelectedRows = async (selecedRows: AdhocHoldOfCntrEntity[]) => {
        adhocHoldOfCntrDispatch(prevState => {

            return {
                ...prevState,
                selectedRows: selecedRows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const onSearchClick = async () => {
        adhocHoldOfCntrDispatch(prevState => {

            return {
                ...prevState,
                isShowSearchPanel: !prevState.isShowSearchPanel,
            }
        })
    }

    const onEditClick = async () => {
        adhocHoldOfCntrDispatch(prevState => {

            return {
                ...prevState,
                isEdit: true,
                currentEditRow: prevState.currentRow,
            }
        })
    }

    const onResetClick = async () => {
        adhocHoldOfCntrDispatch(prevState => {

            return {
                ...prevState,
                currentEditRow: prevState.currentRow,
            }
        })
    }

    const onCloseEidtPanel = async () => {
        adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                isAdd: false,
                isEdit: false,
                isShowEditPanel: false,
                currentEditRow: { ...EMPTY_ADHOC_HOLD_OF_CNTR_ENTITY },
            }
        })
    }

    const onSearchCriteriaResetClick = async () => {
        adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: { ...EMPTY_ADHOC_HOLD_OF_CNTR_SEARCH_CRITERIA },
            }
        })
    }

    const onHoldClicked = async () => {
        adhocHoldOfCntrDispatch(prevState => ({
            ...prevState,
            isShowReasonPanel: true,
        }))
    }

    const onHold = async (selectCharges: AdhocHoldOfCntrEntity[]): Promise<ResponseEntity> => {
        closeRejectReasonModal();
        return await adhocHoldOfCntrRepo.onHold(selectCharges);
    }

    const onSearch = async (searchCriteria: AdhocHoldOfCntrSearchCriteria) => {
        adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                // adhocHoldDataList: [],
                searchCriteria: searchCriteria,
            }
        })
        await adhocHoldOfCntrRepo.getAdhocHoldDatas(searchCriteria).then((data) => {
            adhocHoldOfCntrDispatch(prevState => {
                return {
                    ...prevState,
                    adhocHoldDataList: data,
                }
            })
        }).catch((error) => {
            return [];
        })
    }

    const onSearchFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;

        adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                searchCriteria: {
                    ...prevState.searchCriteria,
                    [fieldKey]: val,
                },
            }
        })
    }

    const onSearchCoVslVoyChange = (inputData: { co?: string, vsl?: string, voy?: string }, fieldName: { co: string, vsl: string, voy: string }) => {
        let coVal: string = "";
        let vslVal: string = "";
        let voyVal: string = "";
        if (inputData?.co) {
            coVal = inputData?.co.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.vsl) {
            vslVal = inputData?.vsl.toUpperCase().replace(/\s+/g, '');
        }
        if (inputData?.voy) {
            voyVal = inputData?.voy.toUpperCase();
        }

        adhocHoldOfCntrDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName.co]: coVal,
                [fieldName.vsl]: vslVal,
                [fieldName.voy]: voyVal,
            }
        }))
    }

    const onFieldChange = (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        return adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                [fieldKey]: val
            }
        });
    }

    const onTextAreaChange = (e: ChangeEvent<HTMLTextAreaElement>, fieldName: string, toUpperCase: boolean = false) => {
        const val = toUpperCase ? e.target.value.toString().toUpperCase() : e.target.value
        adhocHoldOfCntrDispatch(prevState => ({
            ...prevState,
            searchCriteria: {
                ...prevState.searchCriteria,
                [fieldName]: fieldName === 'cntrNoList' ?
                    (val && val.toString().includes(",") ? val.toString().split(",") : val === "" ? null : [val.toString()]) :
                    e.target.value.toString(),
            }
        }))
    };

    const closeRejectReasonModal = () => {
        adhocHoldOfCntrDispatch(prevState => ({
            ...prevState,
            isShowReasonPanel: false,
            isCancel: true,
        }))
    };

    const cancelHoldReasonModal = () => {
        adhocHoldOfCntrDispatch(prevState => ({
            ...prevState,
            isShowReasonPanel: false,
            isCancel: false,
        }))
    };

    const afterHoldSuccess = () => {
        adhocHoldOfCntrDispatch(prevState => ({
            ...prevState,
            isCancel: false,
            reasonCode: ""
        }))
    }

    const setIsSearchLoading = (isSearchLoading: boolean) => {
        adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                isSearchLoading: isSearchLoading,
            }
        })
    }

    const onShowLoading = () => {
        adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                isLoading: true,
            }
        })
    }

    const onHideLoading = () => {
        adhocHoldOfCntrDispatch(prevState => {
            return {
                ...prevState,
                isLoading: false,
            }
        })
    }
    return {
        onShowLoading: onShowLoading,
        onHideLoading: onHideLoading,
        onSearchCoVslVoyChange: onSearchCoVslVoyChange,
        onFieldChange: onFieldChange,
        onCloseEidtPanel: onCloseEidtPanel,
        onHold: onHold,
        onSearchFieldChange: onSearchFieldChange,
        onSearchCriteriaResetClick: onSearchCriteriaResetClick,
        onSearch: onSearch,
        onSearchClick: onSearchClick,
        onEditClick: onEditClick,
        onResetClick: onResetClick,
        updateSelectedRows: updateSelectedRows,
        loadDropdownOption: loadDropdownOption,
        onTextAreaChange: onTextAreaChange,
        cancelHoldReasonModal: cancelHoldReasonModal,
        closeRejectReasonModal: closeRejectReasonModal,
        onHoldClicked: onHoldClicked,
        afterHoldSuccess: afterHoldSuccess,
        setIsSearchLoading: setIsSearchLoading,
    }
}